import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import '../../styling/ProductModal.css';
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import CancelMembershipModal from './CancelMembershipModal';

// ConfirmChangeModal Component

const ConfirmChangeModal = ({ isOpen, closeModal, plan, onConfirm, isYearly, openModal }) => {
  const [isUpdating, setIsUpdating] = useState(false);
  
  if (!plan) return null;

  const price = isYearly ? plan.yearlyCost : plan.monthlyCost;

  const handleUpgrade = async () => {
    setIsUpdating(true);
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/update-subscription`,
        {
          planName: plan.name, 
          isYearly: isYearly
        },
        { withCredentials: true }
      );

      // THE FIX: We must extract the nested payload from Axios!
      const payload = response.data.data;

      // Scenario A: They have no card, Stripe sends a Checkout URL!
      if (payload?.requiresCheckout && payload?.checkoutUrl) {
        window.location.href = payload.checkoutUrl; // Teleport to Stripe!
        return;
      }

      // Scenario B: Instant Upgrade (Card already on file)
      alert("Plan updated successfully!");
      closeModal();
      window.location.reload(); 

    } catch (error) {
      console.error("Error updating plan:", error);
      alert(error.response?.data?.message || "Failed to update subscription.");
    } finally {
      setIsUpdating(false);
    }
  };

  const buttonStyle = {
    background: 'white',
    border: '1px solid #d9d9d9',
    padding: '10px 20px',
    width: "310px",
    height: "50px",
    fontSize: '15px',
    color: "#080700",
    cursor: "pointer" // Added pointer here
  };

  const containerStyle = {
    display: 'flex',
    gap: '40px',
    padding: '20px',
    color: '#1C1154',
    marginTop:"-10px"
  };

  const leftboxStyle = {
    border: '1px solid #d9d9d9',
    padding: '20px',
    width: "310px",
    height:'auto',
    marginTop:"-20px"
  };

  const rightboxStyle = {
    border: '1px solid #d9d9d9',
    color:'#625C73',
    padding: '20px',
    width: '528px',
    height: '550px',
    marginTop:"-20px"
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      className="modal-content"
    >
      <span className="close" onClick={closeModal} style={{ cursor: 'pointer', fontSize: '28px' }}>
        &times;
      </span>
      <h2 style={{color:"#2a1980"}}> Change Your Membership</h2>

      <div style={containerStyle}>
        <div style={leftboxStyle}>
          <h2 style={{color:"#2A1980", marginTop:"-5px" }}>{plan.name}</h2>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <h1 style={{ fontSize: '56px', margin: 0 }}>${price}</h1>
            <p style={{ marginLeft: '10px', marginTop: '15px' }}>
              {isYearly ? '/year' : '/month'}<br />
              (billed {isYearly ? 'annually' : 'monthly'})
            </p>
          </div>
          <p>What's included:</p>
          <ul className='modalUl'>
            {plan.features.map((feature, index) => (
              <li key={index} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                <IoIosCheckmarkCircleOutline style={{ marginRight: '8px' }} /> {feature}
              </li>
            ))}
          </ul>
          <button
            style={buttonStyle}
            onClick={()=>{
              closeModal()
              openModal()
            }}
          >
            Change Membership
          </button>
        </div>

        <div style={rightboxStyle}>
          <h2 style={{color:"black", marginTop:"-5px"}}>Changing your Membership</h2>
          <p style={{fontWeight: 'bold'}}>Your current plan will end today.</p>
          <p>Your subscription will end today and your new plan will start immediately.</p>
          <p style={{fontWeight:"bold"}}> Cancellation Info</p>
          <p>By clicking "Agree and subscribe," you agree to be charged and your subscription will auto-renew unless canceled.</p>
          
          <button 
            style={{...buttonStyle, opacity: isUpdating ? 0.7 : 1}} 
            onClick={handleUpgrade}
            disabled={isUpdating}
          >
            {isUpdating ? "Processing..." : "Agree and Subscribe"}
          </button>
        </div>
      </div>
    </Modal>
  );
};
// ProductModal Component

const ProductModal = ({ isModalOpen, closeModal, setIsModalOpen, setIsCancelModalOpen, isCancelModalOpen }) => {


  const [currentIsYearly, setCurrentIsYearly] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [nextPaymentDate, setNextPaymentdate]=useState(null);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [plans, setPlans] = useState([]);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [planToSwitch, setPlanToSwitch] = useState(null);
  const [isYearly, setIsYearly] = useState(false);
  // Add this state variable at the top of ProductModal, near [currentPlan, setCurrentPlan]
  const [currentStatus, setCurrentStatus] = useState(null);

  // Then, inside your fetchData block:
  useEffect(() => {
    const fetchData = async () => {
      try {
        const subscriptionRes = await axios.get(`${process.env.REACT_APP_API_URL}/business-user/subscription`, {
          withCredentials: true,
        });
        
        const sub = subscriptionRes.data.subscription;
        
        setCurrentPlan(sub.planName);
        setNextPaymentdate(sub.nextPaymentDate);
        setCurrentIsYearly(sub.isYearly); 
        
        // --- ADD THIS LINE TO SAVE THE STATUS ('trialing', 'active', etc) ---
        setCurrentStatus(sub.status); 

        const plansRes = await axios.get(`${process.env.REACT_APP_API_URL}/plans`, { withCredentials: true });
        setPlans(plansRes.data.plans || []);
      } catch (error) {
        console.error('Error fetching subscription or plans:', error);
      }
    };

    if (isModalOpen) {
      fetchData();
    }
  }, [isModalOpen]);

  const handlePlanSelect = (planName) => {
    // It is locked ONLY if the plan matches AND they are fully active (not trialing)
    const isLocked = planName === currentPlan && isYearly === currentIsYearly && currentStatus === 'active';
    
    if (!isLocked) {
      setSelectedPlan(planName);
      const planDetails = plans.find(plan => plan.name === planName);
      setPlanToSwitch(planDetails);
    }
  };

  const handleButtonClick = (planName) => {
    const isLocked = planName === currentPlan && isYearly === currentIsYearly && currentStatus === 'active';
    
    if (!isLocked) {
      setSelectedPlan(planName);
      const planDetails = plans.find(plan => plan.name === planName);
      setPlanToSwitch(planDetails);
      setIsConfirmModalOpen(true);
      closeModal();
    }
  };

  const renderButton = (planName) => {
    const isExactCurrentPlan = planName === currentPlan && isYearly === currentIsYearly;

    // 1. If it's their exact plan and they are fully active -> Disabled
    if (isExactCurrentPlan && currentStatus === 'active') {
      return <button className="planButton bselected" disabled>Current Plan</button>;
    }
    
    // 2. If it's their exact plan but they are trialing -> Let them upgrade!
    if (isExactCurrentPlan && currentStatus === 'trialing') {
      return (
        <button
          className={`planButton ${selectedPlan === planName ? 'bselected' : ''}`}
          onClick={() => handleButtonClick(planName)}
        >
          Subscribe Now
        </button>
      );
    }
    
    // 3. Default for all other plans
    return (
      <button
        className={`planButton ${selectedPlan === planName ? 'bselected' : ''}`}
        onClick={() => handleButtonClick(planName)}
      >
        Change Membership
      </button>
    );
  };

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <span className="close" onClick={closeModal}>&times;</span>

        {/* Heading and Toggle */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop:'-15px' }}>
          <h1 style={{ fontSize: '32px', color: '#2A1980' }}>Our Memberships</h1>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ color: !isYearly ? '#2A1980' : '#625C73' }}>Monthly</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
              <span className="slider round"></span>
            </label>
            <span style={{ color: isYearly ? '#2A1980' : '#625C73' }}>Yearly</span>
          </div>
        </div>

        {/* Plans */}

        <div className="plans" style={{marginTop:'-20px'}}>
          {plans.map(plan => {
            const price = isYearly ? plan.yearlyCost: plan.monthlyCost;
            return (
              <div key={plan.name} className={`plan ${selectedPlan === plan.name ? 'pselected' : ''}`} onClick={() => handlePlanSelect(plan.name)}>
                <h2 style={{ color: '#1C1154', marginTop:'-2px', fontSize:'20px' }}>{plan.name}</h2>
                <div style={{ display: 'flex', justifyItems: 'center' }}>
                  <h1 style={{ color: '#1C1154', fontSize: '50px', marginTop: '-20px' }}>${price}</h1>
                   <p style={{ marginTop: '20px', color: '#1C1154', fontWeight:'bold' }}>.99</p>
                  <p style={{ marginTop: '20px', fontSize:'15px' }}>
                    {isYearly ? '/month (billed yearly)' : '/month'}<br />
                  </p>
                </div>
                <p style={{ marginTop: '-34px' }}>Start with everything you need to grow!</p>
                <p style={{ marginTop: '-15px', marginBottom: '-15px' }}>What's included:</p>
                <ul className='modalUl'>
                  {plan.features.map((feature, index) => (
                    <li key={index} style={{ marginBottom: '7px' }}><IoIosCheckmarkCircleOutline /> {feature}</li>
                  ))}
                </ul>
                {renderButton(plan.name)}
              </div>
            );
          })}
        </div>

        <div style={{border: '1px solid var(--unnamed-color-d9d9d9)', background: '#FFFFFF 0% 0% no-repeat padding-box', border: '1px solid #D9D9D9', borderRadius: '5px',  padding:'10px 20px', marginTop:'10px'}}>
          <h2 style={{fontSize:'20px', marginTop:'-2px', marginBottom:'-10px'}}> Cancel Membership </h2>
          <div style={{display:'flex', alignItems:'center'}}>
            <p style={{color:'#625C73'}}>
              Members may cancel their membership at any time. By ending your membership you will lose acces to your boothbloom benefits but will still have access to your account.
            </p>
            <div style={{border: '1px solid #D9D9D9', borderRadius: '3px', fontSize:'15px', background:'#fff', width:'40%', padding:'10px', height:'20%', fontWeight:'bold', textAlign:'center', cursor:'pointer'}} onClick={()=>{setIsCancelModalOpen(true); closeModal()}}>
              Cancel Plan 
            </div>
          </div>


        </div>
      </Modal>

      {/* Confirm Modal */}
      <ConfirmChangeModal
        isOpen={isConfirmModalOpen}
        closeModal={() => setIsConfirmModalOpen(false)}
        plan={planToSwitch}
        onConfirm={() => {}}
        isYearly={isYearly}

        openModal={()=>setIsModalOpen(true)}

      />

      <CancelMembershipModal isCancelModalOpen={isCancelModalOpen} closeCancelModal={()=>{
          setIsCancelModalOpen(false)}} planName={currentPlan} isYearly={isYearly} nextPaymentDate={nextPaymentDate}/>
    </>
  );
};

export default ProductModal;
